import * as Sentry from '@sentry/react';

/**
 * Sentry 初始化（React 版）
 *
 * 用法：在 main.tsx 中 import 并调用 initSentry()
 */

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    // 没有 DSN 则不启用 Sentry
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

/**
 * 手动捕获错误
 */
export function captureError(error: Error, context?: Record<string, unknown>): void {
  try {
    if (context) {
      Sentry.setContext('extra', context);
    }
    Sentry.captureException(error);
  } catch {
    // Sentry 失败不应影响业务
  }
}
